import type { RootState } from '@shared/redux/root-state';

export const globalConfirmModalSelectors = {
  getState: (state: RootState) => state.globalConfirmModal,
};
